import type { ReactNode } from 'react';

// KbdKey — small keyboard-hint chip rendered inline in palette rows, footers,
// and the cmd-K trigger. Uses the global `.kbd` recipe so the chip styling
// stays consistent. Children should be a single character or a short combo
// string (e.g. ⌘K, ↵, Esc).
type KbdKeyProps = {
  children: ReactNode;
  className?: string;
};

export function KbdKey({ children, className }: KbdKeyProps) {
  const cls = ['kbd', className].filter(Boolean).join(' ');
  return <span className={cls}>{children}</span>;
}
